import { useTranslation } from 'react-i18next';
import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { AuditStatus } from '@/api/types';

const STATUS_VARIANT: Record<AuditStatus, NonNullable<BadgeProps['variant']>> = {
  answer_given: 'info',
  answer_satisfied: 'success',
  answer_escalated: 'warning',
  action_proposed: 'info',
  action_succeeded: 'success',
  action_failed: 'destructive',
  action_failed_escalated: 'warning',
  action_rejected: 'secondary',
  action_rejected_escalated: 'warning',
  error: 'destructive',
  config_change: 'outline',
};

export function AuditStatusBadge({ status }: { status: AuditStatus }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Badge variant={STATUS_VARIANT[status]} title={t(`audit.statusHint.${status}`)} className="whitespace-nowrap">
      {t(`audit.status.${status}`)}
    </Badge>
  );
}
